import { Role } from './role';

export class AuthToken {
  userId?: number;
  token?: string;
  expires?: Date;
  role?: Role;
  language?: string;
  homePage?: string;
  requirePasswordChange?: boolean;
  permissions?: any;
  impersonatorId?: number;

  constructor(data?: any) {
    this.userId = data?.userId;
    this.token = data?.token;
    this.language = data?.language;
    this.homePage = data?.homePage;
    this.permissions = data?.permissions;
    this.requirePasswordChange = data?.requirePasswordChange;
    this.role = data?.role;
    this.expires = data?.expires;
    this.impersonatorId = data?.impersonatorId;
  }

}
